import React, { useEffect } from 'react';
import { Box, CardContent, CardHeader, styled } from '@mui/material';
import StyCard from 'routes/HumanResourcesModule/components/ui/StyCard';
import TitleWithTooltip from 'routes/HumanResourcesModule/components/HrDataGrid/TitleWithTooltip';
import { useFullScreen } from 'contexts/FullScreenContext';
import Flex from 'ui/Flex/Flex';

type Props = {
    title: string;
    infoTooltip?: string;
    startAdornment?: React.ReactNode;
    setIsFullScreen?: (v: boolean) => void;
    cardHeaderActions?: React.ReactNode;
    cardFooterActions?: React.ReactNode;
    children: React.ReactNode;
    titleNode?: React.ReactNode;
};

const StyFooterActions = styled(Box, { name: 'StyFooterActions' })({
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '1rem',
    width: '100%',
    padding: '0 1rem 1rem 1rem',
});

const HrCard = ({
    title,
    infoTooltip,
    startAdornment,
    setIsFullScreen = () => {},
    cardHeaderActions,
    cardFooterActions,
    children,
    titleNode,
}: Props): React.ReactElement => {
    const { isFullScreen } = useFullScreen();
    useEffect(() => {
        setIsFullScreen(isFullScreen);
    }, [isFullScreen]);
    return (
        <StyCard
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <CardHeader
                action={
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '0.2rem',
                            alignItems: 'center',
                        }}
                    >
                        {cardHeaderActions !== undefined && cardHeaderActions}
                    </Box>
                }
                sx={(theme) => ({ color: theme.palette.darkGrey, pb: '12px' })}
                titleTypographyProps={{ variant: 'h5' }}
                title={
                    <Flex direction="row">
                        {startAdornment}
                        {titleNode || (
                            <TitleWithTooltip
                                title={title}
                                infoTooltip={infoTooltip}
                            />
                        )}
                    </Flex>
                }
            />
            <CardContent sx={{ pb: '16px !important', pt: '12px', flex: '1' }}>
                {children}
            </CardContent>
            {cardFooterActions && (
                <StyFooterActions>{cardFooterActions}</StyFooterActions>
            )}
        </StyCard>
    );
};
export default HrCard;
